import { SectionAvailability } from "./types";

export function showManagingSectionColumn(sectionAvailability?: SectionAvailability) {
  return sectionAvailability === SectionAvailability.CAN_CREATE;
}
